import registerGeneral from '@/store/modules/register/general';

export default {
  registerGeneral,
};
